// @generated
import { PapiGallection } from '@wix/da-papi-types';

export const galleries: PapiGallection[] = [
  {
    type: 'gallery',
    name: 'Featured',

    owner: {
      username: 'puimun',
      usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
      type: 'regular',
      userId: 528733,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 397,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/puimun/art/Awakened-606616532',
      title: 'Awakened',
      author: {
        username: 'puimun',
        usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
        type: 'regular',
        userId: 528733,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 24,
        favourites: 796,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/mdlMGB0FuTno0rJhDxtsTftRuHk=/fit-in/150x150/filters:no_upscale():origin()/pre00/748e/th/pre/f/2016/123/0/d/awakened_fb_by_puimun-da15wb8.jpg',
          height: 150,
          width: 120,
          transparency: false,
          filesize: 471535,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/BGdfYMOC4LqSvxmhLrE8NPhxRvo=/300x200/filters:fixed_height(100,100):origin()/pre00/748e/th/pre/f/2016/123/0/d/awakened_fb_by_puimun-da15wb8.jpg',
          height: 200,
          width: 160,
          transparency: false,
          filesize: 471535,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/7kE87hJnWTEwafenfm6yqs8UVYQ=/fit-in/300x900/filters:no_upscale():origin()/pre00/748e/th/pre/f/2016/123/0/d/awakened_fb_by_puimun-da15wb8.jpg',
          height: 375,
          width: 300,
          transparency: false,
          filesize: 471535,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/q-YW6BdGVdbJtz0rd6tdldTSXLU=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/748e/th/pre/f/2016/123/0/d/awakened_fb_by_puimun-da15wb8.jpg',
          height: 250,
          width: 200,
          transparency: false,
          filesize: 471535,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/1N1rzyVPkqvZDJK1ufcNGa0-h9I=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/748e/th/pre/f/2016/123/0/d/awakened_fb_by_puimun-da15wb8.jpg',
          height: 350,
          width: 280,
          transparency: false,
          filesize: 471535,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/EjY-opS7EvkEB7HHtBB6SZjjqro=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/748e/th/pre/f/2016/123/0/d/awakened_fb_by_puimun-da15wb8.jpg',
          height: 400,
          width: 320,
          transparency: false,
          filesize: 471535,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://pre00.deviantart.net/748e/th/pre/f/2016/123/0/d/awakened_fb_by_puimun-da15wb8.jpg',
          height: 1000,
          width: 800,
          transparency: false,
          filesize: 471535,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://pre00.deviantart.net/748e/th/pre/f/2016/123/0/d/awakened_fb_by_puimun-da15wb8.jpg',
          height: 1000,
          width: 800,
          transparency: false,
          filesize: 471535,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/8888/f/2016/123/0/d/awakened_fb_by_puimun-da15wb8.jpg',
          height: 1200,
          width: 960,
          transparency: false,
          filesize: 471535,
          isDefault: false,
        },
      ],
      deviationId: 606616532,
      typeId: 1,
      isJournal: false,
      publishedTime: '2016-05-02T10:38:35-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 395953,
    parentId: null,
  },
  {
    type: 'gallery',
    name: 'Dreamdance Oracle',

    owner: {
      username: 'puimun',
      usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
      type: 'regular',
      userId: 528733,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 15,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/puimun/art/Dreamdance-Abandon-362198273',
      title: 'Dreamdance: Abandon',
      author: {
        username: 'puimun',
        usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
        type: 'regular',
        userId: 528733,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 17,
        favourites: 531,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/J94iSreN0EAJo1sc40Cp6hypqmY=/fit-in/150x150/filters:no_upscale():origin()/pre00/15d5/th/pre/f/2013/088/e/e/dreamdance__abandon_by_puimun-d5zn5z5.jpg',
          height: 150,
          width: 103,
          transparency: false,
          filesize: 118733,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/f-d3Zz0YwFqv3dTQtsCfUWAOooU=/300x200/filters:fixed_height(100,100):origin()/pre00/15d5/th/pre/f/2013/088/e/e/dreamdance__abandon_by_puimun-d5zn5z5.jpg',
          height: 200,
          width: 137,
          transparency: false,
          filesize: 118733,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/N2z2hjcNwhJeM_PAHG7lrr-WmqY=/fit-in/300x900/filters:no_upscale():origin()/pre00/15d5/th/pre/f/2013/088/e/e/dreamdance__abandon_by_puimun-d5zn5z5.jpg',
          height: 439,
          width: 300,
          transparency: false,
          filesize: 118733,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/w_yHHmHQ64nF75oo5TtxkDaE0s0=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/15d5/th/pre/f/2013/088/e/e/dreamdance__abandon_by_puimun-d5zn5z5.jpg',
          height: 250,
          width: 171,
          transparency: false,
          filesize: 118733,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/M6J20hogFLYCSiAjbhTW3b4q778=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/15d5/th/pre/f/2013/088/e/e/dreamdance__abandon_by_puimun-d5zn5z5.jpg',
          height: 350,
          width: 239,
          transparency: false,
          filesize: 118733,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/1-pvWnPElPEjGBHNX5DZ0gBPUIg=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/15d5/th/pre/f/2013/088/e/e/dreamdance__abandon_by_puimun-d5zn5z5.jpg',
          height: 400,
          width: 274,
          transparency: false,
          filesize: 118733,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://orig00.deviantart.net/3e91/f/2013/088/e/e/dreamdance__abandon_by_puimun-d5zn5z5.jpg',
          height: 800,
          width: 547,
          transparency: false,
          filesize: 118733,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://orig00.deviantart.net/3e91/f/2013/088/e/e/dreamdance__abandon_by_puimun-d5zn5z5.jpg',
          height: 800,
          width: 547,
          transparency: false,
          filesize: 118733,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/3e91/f/2013/088/e/e/dreamdance__abandon_by_puimun-d5zn5z5.jpg',
          height: 800,
          width: 547,
          transparency: false,
          filesize: 118733,
          isDefault: false,
        },
      ],
      deviationId: 362198273,
      typeId: 1,
      isJournal: false,
      publishedTime: '2013-03-29T00:24:12-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: true,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 40226213,
    parentId: null,
  },
  {
    type: 'gallery',
    name: 'Strange Dreams',

    owner: {
      username: 'puimun',
      usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
      type: 'regular',
      userId: 528733,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 14,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/puimun/art/Labyrinthine-full-series-386417626',
      title: 'Labyrinthine - full series',
      author: {
        username: 'puimun',
        usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
        type: 'regular',
        userId: 528733,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 64,
        favourites: 1431,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/aj_JBq4OmomjW_zihGyqXoNNikM=/fit-in/150x150/filters:no_upscale():origin()/pre00/c971/th/pre/f/2013/199/b/9/labyrinthine___full_series_by_puimun-d6e29qy.jpg',
          height: 116,
          width: 150,
          transparency: false,
          filesize: 186421,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/ACGDEvi9OxKetEFJT5y7HFEnHgg=/300x200/filters:fixed_height(100,100):origin()/pre00/c971/th/pre/f/2013/199/b/9/labyrinthine___full_series_by_puimun-d6e29qy.jpg',
          height: 200,
          width: 259,
          transparency: false,
          filesize: 186421,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/RRRPW04zcLbW2ENs-ACQYgpOms4=/fit-in/300x900/filters:no_upscale():origin()/pre00/c971/th/pre/f/2013/199/b/9/labyrinthine___full_series_by_puimun-d6e29qy.jpg',
          height: 232,
          width: 300,
          transparency: false,
          filesize: 186421,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/pDWSdqSFNcFMb8EIwoWnxGaXDKA=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/c971/th/pre/f/2013/199/b/9/labyrinthine___full_series_by_puimun-d6e29qy.jpg',
          height: 250,
          width: 324,
          transparency: false,
          filesize: 186421,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/VtvAptFuWJ5S14hXfACLSU10G_c=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/c971/th/pre/f/2013/199/b/9/labyrinthine___full_series_by_puimun-d6e29qy.jpg',
          height: 350,
          width: 453,
          transparency: false,
          filesize: 186421,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/dqOTZ6tJJpfGJtwBgzRTOR4tfhs=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/c971/th/pre/f/2013/199/b/9/labyrinthine___full_series_by_puimun-d6e29qy.jpg',
          height: 400,
          width: 518,
          transparency: false,
          filesize: 186421,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://pre00.deviantart.net/c971/th/pre/f/2013/199/b/9/labyrinthine___full_series_by_puimun-d6e29qy.jpg',
          height: 786,
          width: 1017,
          transparency: false,
          filesize: 186421,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://pre00.deviantart.net/c971/th/pre/f/2013/199/b/9/labyrinthine___full_series_by_puimun-d6e29qy.jpg',
          height: 786,
          width: 1017,
          transparency: false,
          filesize: 186421,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/d9e5/f/2013/199/b/9/labyrinthine___full_series_by_puimun-d6e29qy.jpg',
          height: 1020,
          width: 1320,
          transparency: false,
          filesize: 186421,
          isDefault: false,
        },
      ],
      deviationId: 386417626,
      typeId: 1,
      isJournal: false,
      publishedTime: '2013-07-18T14:13:18-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: true,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 43455915,
    parentId: null,
  },
  {
    type: 'gallery',
    name: 'Zodiac Series',

    owner: {
      username: 'puimun',
      usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
      type: 'regular',
      userId: 528733,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 13,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/puimun/art/Zodiac-140499076',
      title: 'Zodiac',
      author: {
        username: 'puimun',
        usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
        type: 'regular',
        userId: 528733,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 226,
        favourites: 3379,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/ZAXU8OlFWOiJItUF80ry0AV145M=/fit-in/150x150/filters:no_upscale():origin()/pre00/514a/th/pre/f/2009/289/a/8/zodiac_by_puimun.jpg',
          height: 150,
          width: 150,
          transparency: false,
          filesize: 95550,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/4iPxgfNReG469BDb329qwTQRXgI=/300x200/filters:fixed_height(100,100):origin()/pre00/514a/th/pre/f/2009/289/a/8/zodiac_by_puimun.jpg',
          height: 200,
          width: 201,
          transparency: false,
          filesize: 95550,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/cTGhud2ZXK18IdS42GiCIX5Y9Pg=/fit-in/300x900/filters:no_upscale():origin()/pre00/514a/th/pre/f/2009/289/a/8/zodiac_by_puimun.jpg',
          height: 299,
          width: 300,
          transparency: false,
          filesize: 95550,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/gQyItXyBscFUygJJzKpxoVzOVBc=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/514a/th/pre/f/2009/289/a/8/zodiac_by_puimun.jpg',
          height: 250,
          width: 251,
          transparency: false,
          filesize: 95550,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/_O1wx3kb81ruOKq1Ptmxr1QMe3Y=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/514a/th/pre/f/2009/289/a/8/zodiac_by_puimun.jpg',
          height: 350,
          width: 351,
          transparency: false,
          filesize: 95550,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/wwEL8L4aHcqf5cAJMYMYOnZB8nk=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/514a/th/pre/f/2009/289/a/8/zodiac_by_puimun.jpg',
          height: 400,
          width: 401,
          transparency: false,
          filesize: 95550,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://orig00.deviantart.net/5963/f/2009/289/a/8/zodiac_by_puimun.jpg',
          height: 700,
          width: 702,
          transparency: false,
          filesize: 95550,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://orig00.deviantart.net/5963/f/2009/289/a/8/zodiac_by_puimun.jpg',
          height: 700,
          width: 702,
          transparency: false,
          filesize: 95550,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/5963/f/2009/289/a/8/zodiac_by_puimun.jpg',
          height: 700,
          width: 702,
          transparency: false,
          filesize: 95550,
          isDefault: false,
        },
      ],
      deviationId: 140499076,
      typeId: 1,
      isJournal: false,
      publishedTime: '2009-10-16T17:13:24-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: true,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 12659417,
    parentId: null,
  },
  {
    type: 'gallery',
    name: 'Tarot Series',

    owner: {
      username: 'puimun',
      usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
      type: 'regular',
      userId: 528733,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 74,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/puimun/art/The-Happy-Squirrel-159350903',
      title: 'The Happy Squirrel',
      author: {
        username: 'puimun',
        usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
        type: 'regular',
        userId: 528733,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 56,
        favourites: 1195,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/c85jRyR-EfcbJEkHvHXoVcvV5tQ=/fit-in/150x150/filters:no_upscale():origin()/pre00/0e9f/th/pre/f/2010/092/8/e/the_happy_squirrel_by_puimun.jpg',
          height: 150,
          width: 93,
          transparency: false,
          filesize: 98407,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/fbj3R7UHmM5D-Z0Nm4fi-SQJat8=/300x200/filters:fixed_height(100,100):origin()/pre00/0e9f/th/pre/f/2010/092/8/e/the_happy_squirrel_by_puimun.jpg',
          height: 200,
          width: 124,
          transparency: false,
          filesize: 98407,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/kNr6p4Lt4bNTV061EahfVrS83Ic=/fit-in/300x900/filters:no_upscale():origin()/pre00/0e9f/th/pre/f/2010/092/8/e/the_happy_squirrel_by_puimun.jpg',
          height: 485,
          width: 300,
          transparency: false,
          filesize: 98407,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/zZ7Kd9P9wtpA4P1d2ClUhqBCuA0=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/0e9f/th/pre/f/2010/092/8/e/the_happy_squirrel_by_puimun.jpg',
          height: 250,
          width: 155,
          transparency: false,
          filesize: 98407,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/cp5guzFbews4wE0p-_2zAYPxHRo=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/0e9f/th/pre/f/2010/092/8/e/the_happy_squirrel_by_puimun.jpg',
          height: 350,
          width: 217,
          transparency: false,
          filesize: 98407,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/oOxr9BlW6TVFrh3J5eXpj_ye-Fc=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/0e9f/th/pre/f/2010/092/8/e/the_happy_squirrel_by_puimun.jpg',
          height: 400,
          width: 247,
          transparency: false,
          filesize: 98407,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://orig00.deviantart.net/a27a/f/2010/092/8/e/the_happy_squirrel_by_puimun.jpg',
          height: 750,
          width: 464,
          transparency: false,
          filesize: 98407,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://orig00.deviantart.net/a27a/f/2010/092/8/e/the_happy_squirrel_by_puimun.jpg',
          height: 750,
          width: 464,
          transparency: false,
          filesize: 98407,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/a27a/f/2010/092/8/e/the_happy_squirrel_by_puimun.jpg',
          height: 750,
          width: 464,
          transparency: false,
          filesize: 98407,
          isDefault: false,
        },
      ],
      deviationId: 159350903,
      typeId: 1,
      isJournal: false,
      publishedTime: '2010-04-02T21:55:00-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: true,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 9750457,
    parentId: null,
  },
  {
    type: 'gallery',
    name: 'Pencils',

    owner: {
      username: 'puimun',
      usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
      type: 'regular',
      userId: 528733,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 12,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/puimun/art/Mab-377008251',
      title: 'Mab',
      author: {
        username: 'puimun',
        usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
        type: 'regular',
        userId: 528733,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 61,
        favourites: 915,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/pbHPBjDz-CyiHJw70V8V6O5jimM=/fit-in/150x150/filters:no_upscale():origin()/pre00/79a1/th/pre/f/2013/160/2/a/mab_by_puimun-d68glff.jpg',
          height: 150,
          width: 89,
          transparency: false,
          filesize: 81667,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/MY7Q3c4RXAD1YqxXqZ_hSEbXkcU=/300x200/filters:fixed_height(100,100):origin()/pre00/79a1/th/pre/f/2013/160/2/a/mab_by_puimun-d68glff.jpg',
          height: 200,
          width: 119,
          transparency: false,
          filesize: 81667,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/plLpCAd27O-0eFizJ--XmDA_Clg=/fit-in/300x900/filters:no_upscale():origin()/pre00/79a1/th/pre/f/2013/160/2/a/mab_by_puimun-d68glff.jpg',
          height: 504,
          width: 300,
          transparency: false,
          filesize: 81667,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/w8SIiSxDhAqkRWVeEFX5r719a-E=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/79a1/th/pre/f/2013/160/2/a/mab_by_puimun-d68glff.jpg',
          height: 250,
          width: 149,
          transparency: false,
          filesize: 81667,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/qDAWyReK9-tpXU6vQswseMzDDzg=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/79a1/th/pre/f/2013/160/2/a/mab_by_puimun-d68glff.jpg',
          height: 350,
          width: 208,
          transparency: false,
          filesize: 81667,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/LIc-ytYFD3XwZXbHKXAYXH8Ufpo=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/79a1/th/pre/f/2013/160/2/a/mab_by_puimun-d68glff.jpg',
          height: 400,
          width: 238,
          transparency: false,
          filesize: 81667,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://orig00.deviantart.net/4686/f/2013/160/2/a/mab_by_puimun-d68glff.jpg',
          height: 883,
          width: 526,
          transparency: false,
          filesize: 81667,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://orig00.deviantart.net/4686/f/2013/160/2/a/mab_by_puimun-d68glff.jpg',
          height: 883,
          width: 526,
          transparency: false,
          filesize: 81667,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/4686/f/2013/160/2/a/mab_by_puimun-d68glff.jpg',
          height: 883,
          width: 526,
          transparency: false,
          filesize: 81667,
          isDefault: false,
        },
      ],
      deviationId: 377008251,
      typeId: 1,
      isJournal: false,
      publishedTime: '2013-06-09T20:42:59-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: true,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 9750521,
    parentId: null,
  },
  {
    type: 'gallery',
    name: 'Black and White',

    owner: {
      username: 'puimun',
      usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
      type: 'regular',
      userId: 528733,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 49,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/puimun/art/Dragon-287152424',
      title: 'Dragon',
      author: {
        username: 'puimun',
        usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
        type: 'regular',
        userId: 528733,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 40,
        favourites: 1088,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/2aDN-D_BX5afD5gsTu75QpvIeIw=/fit-in/150x150/filters:no_upscale():origin()/pre00/b9be/th/pre/f/2012/056/5/f/dragon_by_puimun-d4qyo88.jpg',
          height: 150,
          width: 100,
          transparency: false,
          filesize: 197864,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/qqgr_47WAofUgyPIAYTuZ3dsEZA=/300x200/filters:fixed_height(100,100):origin()/pre00/b9be/th/pre/f/2012/056/5/f/dragon_by_puimun-d4qyo88.jpg',
          height: 200,
          width: 133,
          transparency: false,
          filesize: 197864,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/Nx08z3qdBVI0RwAf-vcmps0BcEs=/fit-in/300x900/filters:no_upscale():origin()/pre00/b9be/th/pre/f/2012/056/5/f/dragon_by_puimun-d4qyo88.jpg',
          height: 450,
          width: 300,
          transparency: false,
          filesize: 197864,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/fUudlxzW2FT5j5lSa1hpTObYKTY=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/b9be/th/pre/f/2012/056/5/f/dragon_by_puimun-d4qyo88.jpg',
          height: 250,
          width: 167,
          transparency: false,
          filesize: 197864,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/k73IiDtVOD5YeeFTXj9K8vHyRXI=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/b9be/th/pre/f/2012/056/5/f/dragon_by_puimun-d4qyo88.jpg',
          height: 350,
          width: 233,
          transparency: false,
          filesize: 197864,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/zystsc5nvCR--22_GDA0eSOvLO8=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/b9be/th/pre/f/2012/056/5/f/dragon_by_puimun-d4qyo88.jpg',
          height: 400,
          width: 267,
          transparency: false,
          filesize: 197864,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://orig00.deviantart.net/a20e/f/2012/056/5/f/dragon_by_puimun-d4qyo88.jpg',
          height: 1000,
          width: 667,
          transparency: false,
          filesize: 197864,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://orig00.deviantart.net/a20e/f/2012/056/5/f/dragon_by_puimun-d4qyo88.jpg',
          height: 1000,
          width: 667,
          transparency: false,
          filesize: 197864,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/a20e/f/2012/056/5/f/dragon_by_puimun-d4qyo88.jpg',
          height: 1000,
          width: 667,
          transparency: false,
          filesize: 197864,
          isDefault: false,
        },
      ],
      deviationId: 287152424,
      typeId: 1,
      isJournal: false,
      publishedTime: '2012-02-25T15:15:59-0800',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: true,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 9750473,
    parentId: null,
  },
  {
    type: 'gallery',
    name: 'Watercolors',

    owner: {
      username: 'puimun',
      usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
      type: 'regular',
      userId: 528733,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 230,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/puimun/art/Awakened-606616532',
      title: 'Awakened',
      author: {
        username: 'puimun',
        usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
        type: 'regular',
        userId: 528733,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 24,
        favourites: 796,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/mdlMGB0FuTno0rJhDxtsTftRuHk=/fit-in/150x150/filters:no_upscale():origin()/pre00/748e/th/pre/f/2016/123/0/d/awakened_fb_by_puimun-da15wb8.jpg',
          height: 150,
          width: 120,
          transparency: false,
          filesize: 471535,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/BGdfYMOC4LqSvxmhLrE8NPhxRvo=/300x200/filters:fixed_height(100,100):origin()/pre00/748e/th/pre/f/2016/123/0/d/awakened_fb_by_puimun-da15wb8.jpg',
          height: 200,
          width: 160,
          transparency: false,
          filesize: 471535,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/7kE87hJnWTEwafenfm6yqs8UVYQ=/fit-in/300x900/filters:no_upscale():origin()/pre00/748e/th/pre/f/2016/123/0/d/awakened_fb_by_puimun-da15wb8.jpg',
          height: 375,
          width: 300,
          transparency: false,
          filesize: 471535,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/q-YW6BdGVdbJtz0rd6tdldTSXLU=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/748e/th/pre/f/2016/123/0/d/awakened_fb_by_puimun-da15wb8.jpg',
          height: 250,
          width: 200,
          transparency: false,
          filesize: 471535,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/1N1rzyVPkqvZDJK1ufcNGa0-h9I=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/748e/th/pre/f/2016/123/0/d/awakened_fb_by_puimun-da15wb8.jpg',
          height: 350,
          width: 280,
          transparency: false,
          filesize: 471535,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/EjY-opS7EvkEB7HHtBB6SZjjqro=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/748e/th/pre/f/2016/123/0/d/awakened_fb_by_puimun-da15wb8.jpg',
          height: 400,
          width: 320,
          transparency: false,
          filesize: 471535,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://pre00.deviantart.net/748e/th/pre/f/2016/123/0/d/awakened_fb_by_puimun-da15wb8.jpg',
          height: 1000,
          width: 800,
          transparency: false,
          filesize: 471535,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://pre00.deviantart.net/748e/th/pre/f/2016/123/0/d/awakened_fb_by_puimun-da15wb8.jpg',
          height: 1000,
          width: 800,
          transparency: false,
          filesize: 471535,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/8888/f/2016/123/0/d/awakened_fb_by_puimun-da15wb8.jpg',
          height: 1200,
          width: 960,
          transparency: false,
          filesize: 471535,
          isDefault: false,
        },
      ],
      deviationId: 606616532,
      typeId: 1,
      isJournal: false,
      publishedTime: '2016-05-02T10:38:35-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 9750476,
    parentId: null,
  },
  {
    type: 'gallery',
    name: 'Writings',

    owner: {
      username: 'puimun',
      usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
      type: 'regular',
      userId: 528733,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 1,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/puimun/art/Abandoning-Preciousness-366223569',
      title: 'Abandoning Preciousness',
      author: {
        username: 'puimun',
        usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
        type: 'regular',
        userId: 528733,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 157,
        favourites: 363,
      },
      files: [
        {
          type: 'preview',
          src: 'https://img00.deviantart.net/bb46/a/shared/poetry.jpg',
          height: 220,
          width: 500,
          transparency: false,
          isDefault: true,
        },
      ],
      deviationId: 366223569,
      typeId: 1,
      isJournal: false,
      publishedTime: '2013-04-17T09:57:43-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],

      textContent: {
        excerpt:
          ' The most important thing about creating art is to create. If you want to be at ease with creativity, you have to immerse yourself in it, and do a little bit every day. Even if that little bit is only to take five minutes while waiting for the bus to come and do a gesture drawing of a man reading his book across the street from you. Or to take the moment to scribble down a thumbnail rough sketch of a concept that occurs to you. Do a little bit each day. Train your brain to think visually.\n\nIt can be difficult at first, accustoming yourself to make this small bit of time, because you’ll think:\n“I don’t have enough time for it',
        html: {
          type: 'writer',
          features: '',
        },
      },
    },
    folderId: 43455914,
    parentId: null,
  },
  {
    type: 'gallery',
    name: 'Sewing',

    owner: {
      username: 'puimun',
      usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
      type: 'regular',
      userId: 528733,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 4,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/puimun/art/Elmo-Plushie-271064750',
      title: 'Elmo Plushie',
      author: {
        username: 'puimun',
        usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
        type: 'regular',
        userId: 528733,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 51,
        favourites: 131,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/CskALMbiYeH4hM7bk3GxzjsDNNw=/fit-in/150x150/filters:no_upscale():origin()/pre00/957b/th/pre/i/2011/330/f/d/elmo_plushie_by_puimun-d4hduwe.jpg',
          height: 150,
          width: 118,
          transparency: false,
          filesize: 161760,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/5pdxQ6aSb0xg1H1sbJThr9tqWLk=/300x200/filters:fixed_height(100,100):origin()/pre00/957b/th/pre/i/2011/330/f/d/elmo_plushie_by_puimun-d4hduwe.jpg',
          height: 200,
          width: 157,
          transparency: false,
          filesize: 161760,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/jFhJQzg7d2idl8rtGfbSC3ucL1Q=/fit-in/300x900/filters:no_upscale():origin()/pre00/957b/th/pre/i/2011/330/f/d/elmo_plushie_by_puimun-d4hduwe.jpg',
          height: 382,
          width: 300,
          transparency: false,
          filesize: 161760,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/hhf4tMY32n-ncH-4M1ygBF2znnQ=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/957b/th/pre/i/2011/330/f/d/elmo_plushie_by_puimun-d4hduwe.jpg',
          height: 250,
          width: 196,
          transparency: false,
          filesize: 161760,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/imsvYBCjmadnQea-iD4I5TuCw7M=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/957b/th/pre/i/2011/330/f/d/elmo_plushie_by_puimun-d4hduwe.jpg',
          height: 350,
          width: 275,
          transparency: false,
          filesize: 161760,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/rNuqtyHz3cGmnEPo8BVygETSHrA=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/957b/th/pre/i/2011/330/f/d/elmo_plushie_by_puimun-d4hduwe.jpg',
          height: 400,
          width: 314,
          transparency: false,
          filesize: 161760,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://pre00.deviantart.net/957b/th/pre/i/2011/330/f/d/elmo_plushie_by_puimun-d4hduwe.jpg',
          height: 1008,
          width: 792,
          transparency: false,
          filesize: 161760,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://pre00.deviantart.net/957b/th/pre/i/2011/330/f/d/elmo_plushie_by_puimun-d4hduwe.jpg',
          height: 1008,
          width: 792,
          transparency: false,
          filesize: 161760,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://img00.deviantart.net/77a3/i/2011/330/f/d/elmo_plushie_by_puimun-d4hduwe.jpg',
          height: 1145,
          width: 900,
          transparency: false,
          filesize: 161760,
          isDefault: false,
        },
      ],
      deviationId: 271064750,
      typeId: 1,
      isJournal: false,
      publishedTime: '2011-11-26T14:17:07-0800',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: true,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 25115438,
    parentId: 40226213,
  },
  {
    type: 'gallery',
    name: 'Sculpture',

    owner: {
      username: 'puimun',
      usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
      type: 'regular',
      userId: 528733,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 3,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/puimun/art/Wedding-Cake-Topper-Sculpture-12518946',
      title: 'Wedding Cake Topper Sculpture',
      author: {
        username: 'puimun',
        usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
        type: 'regular',
        userId: 528733,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 136,
        favourites: 244,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/x95HIcfb14UXAzxZt8LdQdazyws=/fit-in/150x150/filters:no_upscale():origin()/pre00/9663/th/pre/i/2004/327/6/7/wedding_cake_topper_sculpture_by_puimun.jpg',
          height: 150,
          width: 78,
          transparency: false,
          filesize: 164061,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/I3bm6i4l-vsb4ZQP71Dx2z6U6j8=/300x200/filters:fixed_height(100,100):origin()/pre00/9663/th/pre/i/2004/327/6/7/wedding_cake_topper_sculpture_by_puimun.jpg',
          height: 200,
          width: 104,
          transparency: false,
          filesize: 164061,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/xovja56sQs86NxbQHojeP9GpQJE=/fit-in/300x900/filters:no_upscale():origin()/pre00/9663/th/pre/i/2004/327/6/7/wedding_cake_topper_sculpture_by_puimun.jpg',
          height: 576,
          width: 300,
          transparency: false,
          filesize: 164061,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/-EzJxuC-Qk98EeSPe4SuxUixfps=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/9663/th/pre/i/2004/327/6/7/wedding_cake_topper_sculpture_by_puimun.jpg',
          height: 250,
          width: 130,
          transparency: false,
          filesize: 164061,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/mlrPMBxcOtzJWeXRvWqhDz1XpkI=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/9663/th/pre/i/2004/327/6/7/wedding_cake_topper_sculpture_by_puimun.jpg',
          height: 350,
          width: 182,
          transparency: false,
          filesize: 164061,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/_hBMnkCzTC2bZ5C95HQ-TX4Y2jY=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/9663/th/pre/i/2004/327/6/7/wedding_cake_topper_sculpture_by_puimun.jpg',
          height: 400,
          width: 208,
          transparency: false,
          filesize: 164061,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://img00.deviantart.net/70a2/i/2004/327/6/7/wedding_cake_topper_sculpture_by_puimun.jpg',
          height: 1208,
          width: 629,
          transparency: false,
          filesize: 164061,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://img00.deviantart.net/70a2/i/2004/327/6/7/wedding_cake_topper_sculpture_by_puimun.jpg',
          height: 1208,
          width: 629,
          transparency: false,
          filesize: 164061,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://img00.deviantart.net/70a2/i/2004/327/6/7/wedding_cake_topper_sculpture_by_puimun.jpg',
          height: 1208,
          width: 629,
          transparency: false,
          filesize: 164061,
          isDefault: false,
        },
      ],
      deviationId: 12518946,
      typeId: 1,
      isJournal: false,
      publishedTime: '2004-11-22T00:24:56-0800',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: false,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: true,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 9750469,
    parentId: 40226213,
  },
  {
    type: 'gallery',
    name: 'Wallpapers',

    owner: {
      username: 'puimun',
      usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
      type: 'regular',
      userId: 528733,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 3,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/puimun/art/Tam-Lin-Wallpaper-176968299',
      title: 'Tam Lin Wallpaper',
      author: {
        username: 'puimun',
        usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
        type: 'regular',
        userId: 528733,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 41,
        favourites: 839,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/dxk_MkxE0J1VeEwJK1cigbtXyWw=/fit-in/150x150/filters:no_upscale():origin()/pre00/0b82/th/pre/f/2010/238/2/3/tam_lin_wallpaper_by_puimun.jpg',
          height: 59,
          width: 150,
          transparency: false,
          filesize: 261712,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/3hs6kxRagpvFbBOiKB5duwQ-7qk=/300x200/filters:fixed_height(100,100):origin()/pre00/0b82/th/pre/f/2010/238/2/3/tam_lin_wallpaper_by_puimun.jpg',
          height: 117,
          width: 300,
          transparency: false,
          filesize: 261712,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/9kPy_yW0mJN0KADr6AFXGKYb4nY=/fit-in/300x900/filters:no_upscale():origin()/pre00/0b82/th/pre/f/2010/238/2/3/tam_lin_wallpaper_by_puimun.jpg',
          height: 117,
          width: 300,
          transparency: false,
          filesize: 261712,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/NX_ptHWEhQNNrBQNGgkF54DiIFc=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/0b82/th/pre/f/2010/238/2/3/tam_lin_wallpaper_by_puimun.jpg',
          height: 195,
          width: 500,
          transparency: false,
          filesize: 261712,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/zvTUwjqSxjaDBFiLnC8iK53IQBo=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/0b82/th/pre/f/2010/238/2/3/tam_lin_wallpaper_by_puimun.jpg',
          height: 273,
          width: 700,
          transparency: false,
          filesize: 261712,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/pLlac-RWb7HxT-SruYmjuTEfww4=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/0b82/th/pre/f/2010/238/2/3/tam_lin_wallpaper_by_puimun.jpg',
          height: 313,
          width: 800,
          transparency: false,
          filesize: 261712,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://pre00.deviantart.net/0b82/th/pre/f/2010/238/2/3/tam_lin_wallpaper_by_puimun.jpg',
          height: 559,
          width: 1431,
          transparency: false,
          filesize: 261712,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://pre00.deviantart.net/0b82/th/pre/f/2010/238/2/3/tam_lin_wallpaper_by_puimun.jpg',
          height: 559,
          width: 1431,
          transparency: false,
          filesize: 261712,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/9cf2/f/2010/238/2/3/tam_lin_wallpaper_by_puimun.jpg',
          height: 750,
          width: 1920,
          transparency: false,
          filesize: 261712,
          isDefault: false,
        },
      ],
      deviationId: 176968299,
      typeId: 1,
      isJournal: false,
      publishedTime: '2010-08-26T21:55:38-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: true,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 9750459,
    parentId: null,
  },
  {
    type: 'gallery',
    name: 'Knotwork',

    owner: {
      username: 'puimun',
      usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
      type: 'regular',
      userId: 528733,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 7,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/puimun/art/Coyote-and-Bear-Knot-142862755',
      title: 'Coyote and Bear Knot',
      author: {
        username: 'puimun',
        usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
        type: 'regular',
        userId: 528733,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 76,
        favourites: 1248,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/GNLKEfgFCYlXmNmtIDt53PXdnHY=/fit-in/150x150/filters:no_upscale():origin()/pre00/5448/th/pre/f/2009/311/f/f/coyote_and_bear_knot_by_puimun.jpg',
          height: 150,
          width: 146,
          transparency: false,
          filesize: 152387,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/4iE5AUGam8TXO5ADMcn-3mekqFs=/300x200/filters:fixed_height(100,100):origin()/pre00/5448/th/pre/f/2009/311/f/f/coyote_and_bear_knot_by_puimun.jpg',
          height: 200,
          width: 194,
          transparency: false,
          filesize: 152387,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/N64Z-sLS6IPg3sCWZQFY1br3VM8=/fit-in/300x900/filters:no_upscale():origin()/pre00/5448/th/pre/f/2009/311/f/f/coyote_and_bear_knot_by_puimun.jpg',
          height: 309,
          width: 300,
          transparency: false,
          filesize: 152387,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/F_imDdJ_cEMVsYgGIIDd8AoN5Mw=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/5448/th/pre/f/2009/311/f/f/coyote_and_bear_knot_by_puimun.jpg',
          height: 250,
          width: 243,
          transparency: false,
          filesize: 152387,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/vLfDFro2v0TZ1lFucuwnQrP0-90=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/5448/th/pre/f/2009/311/f/f/coyote_and_bear_knot_by_puimun.jpg',
          height: 350,
          width: 340,
          transparency: false,
          filesize: 152387,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/BOozNpAGdaNt1Op-1oyfPw2KhSI=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/5448/th/pre/f/2009/311/f/f/coyote_and_bear_knot_by_puimun.jpg',
          height: 400,
          width: 388,
          transparency: false,
          filesize: 152387,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://orig00.deviantart.net/7bde/f/2009/311/f/f/coyote_and_bear_knot_by_puimun.jpg',
          height: 800,
          width: 776,
          transparency: false,
          filesize: 152387,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://orig00.deviantart.net/7bde/f/2009/311/f/f/coyote_and_bear_knot_by_puimun.jpg',
          height: 800,
          width: 776,
          transparency: false,
          filesize: 152387,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/7bde/f/2009/311/f/f/coyote_and_bear_knot_by_puimun.jpg',
          height: 800,
          width: 776,
          transparency: false,
          filesize: 152387,
          isDefault: false,
        },
      ],
      deviationId: 142862755,
      typeId: 1,
      isJournal: false,
      publishedTime: '2009-11-07T17:46:35-0800',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: true,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 23675889,
    parentId: null,
  },
  {
    type: 'gallery',
    name: 'Photo',

    owner: {
      username: 'puimun',
      usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
      type: 'regular',
      userId: 528733,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 3,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/puimun/art/Twists-and-Swirls-187685580',
      title: 'Twists and Swirls',
      author: {
        username: 'puimun',
        usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
        type: 'regular',
        userId: 528733,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 67,
        favourites: 450,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/FD2WokG1-2xb1rQWzRvetKo6Uzc=/fit-in/150x150/filters:no_upscale():origin()/pre00/7f7f/th/pre/f/2010/331/b/f/twists_and_swirls_by_puimun-d33qr4c.jpg',
          height: 150,
          width: 80,
          transparency: false,
          filesize: 101394,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/vSrmiMGMe_IFf7ysKcXH419wOcw=/300x200/filters:fixed_height(100,100):origin()/pre00/7f7f/th/pre/f/2010/331/b/f/twists_and_swirls_by_puimun-d33qr4c.jpg',
          height: 200,
          width: 107,
          transparency: false,
          filesize: 101394,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/dYuu5RM8axpuMY7HzTzIypYAu0I=/fit-in/300x900/filters:no_upscale():origin()/pre00/7f7f/th/pre/f/2010/331/b/f/twists_and_swirls_by_puimun-d33qr4c.jpg',
          height: 559,
          width: 300,
          transparency: false,
          filesize: 101394,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/3Ji7hlvM23kU0SDpiwWO_7tdtpE=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/7f7f/th/pre/f/2010/331/b/f/twists_and_swirls_by_puimun-d33qr4c.jpg',
          height: 250,
          width: 134,
          transparency: false,
          filesize: 101394,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/_In1aY-ARYXtkxMPT6pGOWECLq4=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/7f7f/th/pre/f/2010/331/b/f/twists_and_swirls_by_puimun-d33qr4c.jpg',
          height: 350,
          width: 188,
          transparency: false,
          filesize: 101394,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/9N2FvwNHQdV5Cu1Q6tRP8Sa90Hg=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/7f7f/th/pre/f/2010/331/b/f/twists_and_swirls_by_puimun-d33qr4c.jpg',
          height: 400,
          width: 215,
          transparency: false,
          filesize: 101394,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://orig00.deviantart.net/7dbb/f/2010/331/b/f/twists_and_swirls_by_puimun-d33qr4c.jpg',
          height: 1042,
          width: 559,
          transparency: false,
          filesize: 101394,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://orig00.deviantart.net/7dbb/f/2010/331/b/f/twists_and_swirls_by_puimun-d33qr4c.jpg',
          height: 1042,
          width: 559,
          transparency: false,
          filesize: 101394,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/7dbb/f/2010/331/b/f/twists_and_swirls_by_puimun-d33qr4c.jpg',
          height: 1042,
          width: 559,
          transparency: false,
          filesize: 101394,
          isDefault: false,
        },
      ],
      deviationId: 187685580,
      typeId: 1,
      isJournal: false,
      publishedTime: '2010-11-27T16:01:09-0800',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: true,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 9750543,
    parentId: null,
  },
  {
    type: 'gallery',
    name: 'horoscope series  season 1complete',

    owner: {
      username: 'sakimichan',
      usericon: 'https://a.deviantart.net/avatars/s/a/sakimichan.jpg?4',
      type: 'senior',
      userId: 2321415,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 14,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/sakimichan/art/Horoscope-2017-Desk-Calendar-available-651454349',
      title: 'Horoscope 2017 Desk Calendar available',
      author: {
        username: 'sakimichan',
        usericon: 'https://a.deviantart.net/avatars/s/a/sakimichan.jpg?4',
        type: 'senior',
        userId: 2321415,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 291,
        favourites: 3424,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/-CI-tHWSsOa2yD3IRRWr9LU68Ro=/fit-in/150x150/filters:no_upscale():origin()/pre00/243f/th/pre/f/2016/350/1/a/1a763b807da7eff4f2b3b8de79ac41b1-daruxe5.jpg',
          height: 150,
          width: 52,
          transparency: false,
          filesize: 1902924,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/t-bECg6qBiHFi8F1J8-2-2kwQsM=/300x200/filters:fixed_height(100,100):origin()/pre00/243f/th/pre/f/2016/350/1/a/1a763b807da7eff4f2b3b8de79ac41b1-daruxe5.jpg',
          height: 201,
          width: 100,
          transparency: false,
          filesize: 1902924,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/UneIg7t3SSxD42pWCkUlveGs8GQ=/fit-in/300x900/filters:no_upscale():origin()/pre00/243f/th/pre/f/2016/350/1/a/1a763b807da7eff4f2b3b8de79ac41b1-daruxe5.jpg',
          height: 859,
          width: 300,
          transparency: false,
          filesize: 1902924,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/lJndoAjwl8WoVnnEfkE55gtCiQ8=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/243f/th/pre/f/2016/350/1/a/1a763b807da7eff4f2b3b8de79ac41b1-daruxe5.jpg',
          height: 250,
          width: 87,
          transparency: false,
          filesize: 1902924,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/J92c5lDvb7p04SbM5TA9WxAdwy0=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/243f/th/pre/f/2016/350/1/a/1a763b807da7eff4f2b3b8de79ac41b1-daruxe5.jpg',
          height: 350,
          width: 122,
          transparency: false,
          filesize: 1902924,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/FES2ix-j-H14MM048Of7j5n-_dw=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/243f/th/pre/f/2016/350/1/a/1a763b807da7eff4f2b3b8de79ac41b1-daruxe5.jpg',
          height: 400,
          width: 140,
          transparency: false,
          filesize: 1902924,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://pre00.deviantart.net/243f/th/pre/f/2016/350/1/a/1a763b807da7eff4f2b3b8de79ac41b1-daruxe5.jpg',
          height: 1513,
          width: 528,
          transparency: false,
          filesize: 1902924,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://pre00.deviantart.net/243f/th/pre/f/2016/350/1/a/1a763b807da7eff4f2b3b8de79ac41b1-daruxe5.jpg',
          height: 1513,
          width: 528,
          transparency: false,
          filesize: 1902924,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/0c23/f/2016/350/1/a/1a763b807da7eff4f2b3b8de79ac41b1-daruxe5.jpg',
          height: 2004,
          width: 700,
          transparency: false,
          filesize: 1902924,
          isDefault: false,
        },
      ],
      deviationId: 651454349,
      typeId: 1,
      isJournal: false,
      publishedTime: '2016-12-15T18:22:23-0800',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 60051312,
    parentId: null,
  },
  {
    type: 'gallery',
    name: 'Chinese Zodiac',

    owner: {
      username: 'sakimichan',
      usericon: 'https://a.deviantart.net/avatars/s/a/sakimichan.jpg?4',
      type: 'senior',
      userId: 2321415,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 6,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/sakimichan/art/Chinese-Zodiac-Snake-673552616',
      title: 'Chinese Zodiac.:Snake:.',
      author: {
        username: 'sakimichan',
        usericon: 'https://a.deviantart.net/avatars/s/a/sakimichan.jpg?4',
        type: 'senior',
        userId: 2321415,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 366,
        favourites: 16584,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/_be1ppQB0gVSaMO4yVTGEOeftGA=/fit-in/150x150/filters:no_upscale():origin()/pre00/d787/th/pre/f/2017/097/a/9/a94e5c58e97d2b9ec0e7e62e3eb2889a-db50kiw.jpg',
          height: 150,
          width: 109,
          transparency: false,
          filesize: 616086,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/j6wZMcY9HN7j1ETRY5GUFxaQqgY=/300x200/filters:fixed_height(100,100):origin()/pre00/d787/th/pre/f/2017/097/a/9/a94e5c58e97d2b9ec0e7e62e3eb2889a-db50kiw.jpg',
          height: 200,
          width: 145,
          transparency: false,
          filesize: 616086,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/nNp0K4XfGZMQW3muLFz8bC6IzqQ=/fit-in/300x900/filters:no_upscale():origin()/pre00/d787/th/pre/f/2017/097/a/9/a94e5c58e97d2b9ec0e7e62e3eb2889a-db50kiw.jpg',
          height: 413,
          width: 300,
          transparency: false,
          filesize: 616086,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/oySSuu5lJJw8yg2O4TNwZAtT89o=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/d787/th/pre/f/2017/097/a/9/a94e5c58e97d2b9ec0e7e62e3eb2889a-db50kiw.jpg',
          height: 250,
          width: 182,
          transparency: false,
          filesize: 616086,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/qVTqrUH6t4-ZCmquS-UskxJy5rc=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/d787/th/pre/f/2017/097/a/9/a94e5c58e97d2b9ec0e7e62e3eb2889a-db50kiw.jpg',
          height: 350,
          width: 254,
          transparency: false,
          filesize: 616086,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/EyUL8s-dFFzCQHmbOJOOM1K_kGY=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/d787/th/pre/f/2017/097/a/9/a94e5c58e97d2b9ec0e7e62e3eb2889a-db50kiw.jpg',
          height: 400,
          width: 291,
          transparency: false,
          filesize: 616086,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://orig00.deviantart.net/ace8/f/2017/097/a/9/a94e5c58e97d2b9ec0e7e62e3eb2889a-db50kiw.jpg',
          height: 1000,
          width: 727,
          transparency: false,
          filesize: 616086,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://orig00.deviantart.net/ace8/f/2017/097/a/9/a94e5c58e97d2b9ec0e7e62e3eb2889a-db50kiw.jpg',
          height: 1000,
          width: 727,
          transparency: false,
          filesize: 616086,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/ace8/f/2017/097/a/9/a94e5c58e97d2b9ec0e7e62e3eb2889a-db50kiw.jpg',
          height: 1000,
          width: 727,
          transparency: false,
          filesize: 616086,
          isDefault: false,
        },
      ],
      deviationId: 673552616,
      typeId: 1,
      isJournal: false,
      publishedTime: '2017-04-07T17:35:54-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 61814720,
    parentId: null,
  },
  {
    type: 'gallery',
    name: 'steven universe',

    owner: {
      username: 'sakimichan',
      usericon: 'https://a.deviantart.net/avatars/s/a/sakimichan.jpg?4',
      type: 'senior',
      userId: 2321415,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 3,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/sakimichan/art/Steven-Universe-Garnet-655053725',
      title: 'Steven Universe Garnet',
      author: {
        username: 'sakimichan',
        usericon: 'https://a.deviantart.net/avatars/s/a/sakimichan.jpg?4',
        type: 'senior',
        userId: 2321415,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 358,
        favourites: 14058,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/N0VTAl3ZOJ-3GsAhIuagcvrTZ1k=/fit-in/150x150/filters:no_upscale():origin()/pre00/2b23/th/pre/f/2017/002/4/f/4f8f2177ca7af9f9d867f5fad9028a1a-dau02ot.jpg',
          height: 150,
          width: 116,
          transparency: false,
          filesize: 417970,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/tgegQDtSGsVhQEDdZSFROdOdKBI=/300x200/filters:fixed_height(100,100):origin()/pre00/2b23/th/pre/f/2017/002/4/f/4f8f2177ca7af9f9d867f5fad9028a1a-dau02ot.jpg',
          height: 200,
          width: 155,
          transparency: false,
          filesize: 417970,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/Xb6Zqljeqg_V7RuEAgGeu4tLFQs=/fit-in/300x900/filters:no_upscale():origin()/pre00/2b23/th/pre/f/2017/002/4/f/4f8f2177ca7af9f9d867f5fad9028a1a-dau02ot.jpg',
          height: 388,
          width: 300,
          transparency: false,
          filesize: 417970,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/8aujP-KA5jQMJrkTmRnOpuPYGMU=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/2b23/th/pre/f/2017/002/4/f/4f8f2177ca7af9f9d867f5fad9028a1a-dau02ot.jpg',
          height: 250,
          width: 193,
          transparency: false,
          filesize: 417970,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/P4bAiGbGTSKyz8wwokFYu_AJuQQ=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/2b23/th/pre/f/2017/002/4/f/4f8f2177ca7af9f9d867f5fad9028a1a-dau02ot.jpg',
          height: 350,
          width: 271,
          transparency: false,
          filesize: 417970,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/bctPWJ6-fOQ7_AUFJqnE7njJWIA=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/2b23/th/pre/f/2017/002/4/f/4f8f2177ca7af9f9d867f5fad9028a1a-dau02ot.jpg',
          height: 400,
          width: 309,
          transparency: false,
          filesize: 417970,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://orig00.deviantart.net/4757/f/2017/002/4/f/4f8f2177ca7af9f9d867f5fad9028a1a-dau02ot.jpg',
          height: 1000,
          width: 773,
          transparency: false,
          filesize: 417970,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://orig00.deviantart.net/4757/f/2017/002/4/f/4f8f2177ca7af9f9d867f5fad9028a1a-dau02ot.jpg',
          height: 1000,
          width: 773,
          transparency: false,
          filesize: 417970,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/4757/f/2017/002/4/f/4f8f2177ca7af9f9d867f5fad9028a1a-dau02ot.jpg',
          height: 1000,
          width: 773,
          transparency: false,
          filesize: 417970,
          isDefault: false,
        },
      ],
      deviationId: 655053725,
      typeId: 1,
      isJournal: false,
      publishedTime: '2017-01-02T16:13:52-0800',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 60623118,
    parentId: null,
  },
  {
    type: 'gallery',
    name: 'Siren series',

    owner: {
      username: 'sakimichan',
      usericon: 'https://a.deviantart.net/avatars/s/a/sakimichan.jpg?4',
      type: 'senior',
      userId: 2321415,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 4,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/sakimichan/art/Mini-Faerie-Mermaids-671272753',
      title: 'Mini Faerie Mermaids',
      author: {
        username: 'sakimichan',
        usericon: 'https://a.deviantart.net/avatars/s/a/sakimichan.jpg?4',
        type: 'senior',
        userId: 2321415,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 574,
        favourites: 19030,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/XU6p1ZauNFhxDtqaNGLS1Hk1k_M=/fit-in/150x150/filters:no_upscale():origin()/pre00/39df/th/pre/i/2017/085/f/d/mini_faerie_mermaids_by_sakimichan-db3npdd.jpg',
          height: 84,
          width: 150,
          transparency: false,
          filesize: 184150,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/37aWOoHJZLhHqIcrbub8aG4IMfo=/300x200/filters:fixed_height(100,100):origin()/pre00/39df/th/pre/i/2017/085/f/d/mini_faerie_mermaids_by_sakimichan-db3npdd.jpg',
          height: 169,
          width: 300,
          transparency: false,
          filesize: 184150,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/A9m7mU-irQBcw2qa2CybtLzqXAY=/fit-in/300x900/filters:no_upscale():origin()/pre00/39df/th/pre/i/2017/085/f/d/mini_faerie_mermaids_by_sakimichan-db3npdd.jpg',
          height: 169,
          width: 300,
          transparency: false,
          filesize: 184150,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/ZnETrQbqTrIZmZm7rcMlBls2eZM=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/39df/th/pre/i/2017/085/f/d/mini_faerie_mermaids_by_sakimichan-db3npdd.jpg',
          height: 250,
          width: 444,
          transparency: false,
          filesize: 184150,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/HMAMpyVqH-rdH-10c0DwsvBgvoQ=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/39df/th/pre/i/2017/085/f/d/mini_faerie_mermaids_by_sakimichan-db3npdd.jpg',
          height: 350,
          width: 622,
          transparency: false,
          filesize: 184150,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/GocL-uWH9_FSbWGn0_kBe7RIJD8=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/39df/th/pre/i/2017/085/f/d/mini_faerie_mermaids_by_sakimichan-db3npdd.jpg',
          height: 400,
          width: 711,
          transparency: false,
          filesize: 184150,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://img00.deviantart.net/21d9/i/2017/085/f/d/mini_faerie_mermaids_by_sakimichan-db3npdd.jpg',
          height: 576,
          width: 1024,
          transparency: false,
          filesize: 184150,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://img00.deviantart.net/21d9/i/2017/085/f/d/mini_faerie_mermaids_by_sakimichan-db3npdd.jpg',
          height: 576,
          width: 1024,
          transparency: false,
          filesize: 184150,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://img00.deviantart.net/21d9/i/2017/085/f/d/mini_faerie_mermaids_by_sakimichan-db3npdd.jpg',
          height: 576,
          width: 1024,
          transparency: false,
          filesize: 184150,
          isDefault: false,
        },
      ],
      deviationId: 671272753,
      typeId: 1,
      isJournal: false,
      publishedTime: '2017-03-26T16:53:59-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 61924491,
    parentId: null,
  },
  {
    type: 'gallery',
    name: 'Tutorials . store in description.',

    owner: {
      username: 'sakimichan',
      usericon: 'https://a.deviantart.net/avatars/s/a/sakimichan.jpg?4',
      type: 'senior',
      userId: 2321415,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 173,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/sakimichan/art/Male-female-nsfw-voice-over-guide-pack-promo-759412345',
      title: 'Male + female nsfw voice over guide pack.promo.',
      author: {
        username: 'sakimichan',
        usericon: 'https://a.deviantart.net/avatars/s/a/sakimichan.jpg?4',
        type: 'senior',
        userId: 2321415,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 0,
        favourites: 926,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/GjT-PzXvJALUye505FbyBo2vI2Q=/fit-in/150x150/filters:no_upscale():origin()/pre00/2f17/th/pre/i/2018/226/f/5/male___female_nsfw_voice_over_guide_pack_promo__by_sakimichan-dck4ubd.jpg',
          height: 109,
          width: 150,
          transparency: false,
          filesize: 223390,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/TqRDOuUzlqw18imF0KlPi_Q8dpg=/300x200/filters:fixed_height(100,100):origin()/pre00/2f17/th/pre/i/2018/226/f/5/male___female_nsfw_voice_over_guide_pack_promo__by_sakimichan-dck4ubd.jpg',
          height: 200,
          width: 276,
          transparency: false,
          filesize: 223390,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/divLoinPPEICQawKa56f4UU4CNA=/fit-in/300x900/filters:no_upscale():origin()/pre00/2f17/th/pre/i/2018/226/f/5/male___female_nsfw_voice_over_guide_pack_promo__by_sakimichan-dck4ubd.jpg',
          height: 217,
          width: 300,
          transparency: false,
          filesize: 223390,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/x2usjvE7bcmWOd_8rwLlIqTPppk=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/2f17/th/pre/i/2018/226/f/5/male___female_nsfw_voice_over_guide_pack_promo__by_sakimichan-dck4ubd.jpg',
          height: 250,
          width: 345,
          transparency: false,
          filesize: 223390,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/h5P23UXfw35LEKCHb1Qhsj5nUMU=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/2f17/th/pre/i/2018/226/f/5/male___female_nsfw_voice_over_guide_pack_promo__by_sakimichan-dck4ubd.jpg',
          height: 350,
          width: 483,
          transparency: false,
          filesize: 223390,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/uscMXh2MkyF5Z0QazA0DMHdvQSg=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/2f17/th/pre/i/2018/226/f/5/male___female_nsfw_voice_over_guide_pack_promo__by_sakimichan-dck4ubd.jpg',
          height: 400,
          width: 552,
          transparency: false,
          filesize: 223390,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://img00.deviantart.net/6122/i/2018/226/f/5/male___female_nsfw_voice_over_guide_pack_promo__by_sakimichan-dck4ubd.jpg',
          height: 742,
          width: 1024,
          transparency: false,
          filesize: 223390,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://st.deviantart.net/misc/noentrythumb-200.png',
          height: 200,
          width: 200,
          transparency: false,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://img00.deviantart.net/6122/i/2018/226/f/5/male___female_nsfw_voice_over_guide_pack_promo__by_sakimichan-dck4ubd.jpg',
          height: 742,
          width: 1024,
          transparency: false,
          filesize: 223390,
          isDefault: false,
        },
      ],
      deviationId: 759412345,
      typeId: 1,
      isJournal: false,
      publishedTime: '2018-08-14T10:37:42-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: false,
      isCommentable: false,
      isFavourited: false,
      isDeleted: false,
      isMature: true,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 734842,
    parentId: null,
  },
  {
    type: 'gallery',
    name: 'BL boy love',

    owner: {
      username: 'sakimichan',
      usericon: 'https://a.deviantart.net/avatars/s/a/sakimichan.jpg?4',
      type: 'senior',
      userId: 2321415,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 65,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/sakimichan/art/Sun-Wukong-Rwby-nsfw-tag-759787066',
      title: 'Sun Wukong Rwby .nsfw tag.',
      author: {
        username: 'sakimichan',
        usericon: 'https://a.deviantart.net/avatars/s/a/sakimichan.jpg?4',
        type: 'senior',
        userId: 2321415,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 0,
        favourites: 996,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/y_tsVxtmnn4V91IZH-SeVuBWJ00=/fit-in/150x150/filters:no_upscale():origin()/pre00/f3b5/th/pre/f/2018/228/7/3/sun_wukong_rwby_nsfwpreview_by_sakimichan-dckcvga.jpg',
          height: 138,
          width: 150,
          transparency: false,
          filesize: 189917,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/J4_yakvUe5hN45f9WzzXFJPP4W0=/300x200/filters:fixed_height(100,100):origin()/pre00/f3b5/th/pre/f/2018/228/7/3/sun_wukong_rwby_nsfwpreview_by_sakimichan-dckcvga.jpg',
          height: 200,
          width: 217,
          transparency: false,
          filesize: 189917,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/uA3At7Hi3z140KTPjmTqgEJwAKY=/fit-in/300x900/filters:no_upscale():origin()/pre00/f3b5/th/pre/f/2018/228/7/3/sun_wukong_rwby_nsfwpreview_by_sakimichan-dckcvga.jpg',
          height: 277,
          width: 300,
          transparency: false,
          filesize: 189917,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/fO9PFMfzn4iEJTNoRmZG-xmMm0k=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/f3b5/th/pre/f/2018/228/7/3/sun_wukong_rwby_nsfwpreview_by_sakimichan-dckcvga.jpg',
          height: 250,
          width: 271,
          transparency: false,
          filesize: 189917,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/Llb9nz1dzBL3mn5nW8hBaGFoQ-g=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/f3b5/th/pre/f/2018/228/7/3/sun_wukong_rwby_nsfwpreview_by_sakimichan-dckcvga.jpg',
          height: 350,
          width: 380,
          transparency: false,
          filesize: 189917,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://orig00.deviantart.net/2b65/f/2018/228/7/3/sun_wukong_rwby_nsfwpreview_by_sakimichan-dckcvga.jpg',
          height: 378,
          width: 410,
          transparency: false,
          filesize: 189917,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://orig00.deviantart.net/2b65/f/2018/228/7/3/sun_wukong_rwby_nsfwpreview_by_sakimichan-dckcvga.jpg',
          height: 378,
          width: 410,
          transparency: false,
          filesize: 189917,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://st.deviantart.net/misc/noentrythumb-200.png',
          height: 200,
          width: 200,
          transparency: false,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/2b65/f/2018/228/7/3/sun_wukong_rwby_nsfwpreview_by_sakimichan-dckcvga.jpg',
          height: 378,
          width: 410,
          transparency: false,
          filesize: 189917,
          isDefault: false,
        },
      ],
      deviationId: 759787066,
      typeId: 1,
      isJournal: false,
      publishedTime: '2018-08-16T18:44:05-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: false,
      isCommentable: false,
      isFavourited: false,
      isDeleted: false,
      isMature: true,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 7878494,
    parentId: null,
  },
  {
    type: 'gallery',
    name: 'naruto fanart',

    owner: {
      username: 'sakimichan',
      usericon: 'https://a.deviantart.net/avatars/s/a/sakimichan.jpg?4',
      type: 'senior',
      userId: 2321415,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 23,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/sakimichan/art/Hinata-Naruto-beach-day-627636607',
      title: 'Hinata Naruto beach day',
      author: {
        username: 'sakimichan',
        usericon: 'https://a.deviantart.net/avatars/s/a/sakimichan.jpg?4',
        type: 'senior',
        userId: 2321415,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 426,
        favourites: 14484,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/UqEyHv9ak9C61BK2p-Vj18hgZx0=/fit-in/150x150/filters:no_upscale():origin()/pre00/be21/th/pre/i/2016/224/3/5/hinata_naruto_beach_day_by_sakimichan-dadofi7.jpg',
          height: 150,
          width: 116,
          transparency: false,
          filesize: 189662,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/d3bKnee-9OqDYQV420Id22t39Ho=/300x200/filters:fixed_height(100,100):origin()/pre00/be21/th/pre/i/2016/224/3/5/hinata_naruto_beach_day_by_sakimichan-dadofi7.jpg',
          height: 200,
          width: 155,
          transparency: false,
          filesize: 189662,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/ilPcpsUsqNSPl2dARVjdQD30nx4=/fit-in/300x900/filters:no_upscale():origin()/pre00/be21/th/pre/i/2016/224/3/5/hinata_naruto_beach_day_by_sakimichan-dadofi7.jpg',
          height: 388,
          width: 300,
          transparency: false,
          filesize: 189662,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/TJ_D3WjVgrIQnkrDEo4NfH2X9m0=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/be21/th/pre/i/2016/224/3/5/hinata_naruto_beach_day_by_sakimichan-dadofi7.jpg',
          height: 250,
          width: 193,
          transparency: false,
          filesize: 189662,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/TgW5akaQeaba0mzyUIc_vFE-Z-Y=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/be21/th/pre/i/2016/224/3/5/hinata_naruto_beach_day_by_sakimichan-dadofi7.jpg',
          height: 350,
          width: 270,
          transparency: false,
          filesize: 189662,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/cSTUYqANZe6OO5IXAAelok8WTE4=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/be21/th/pre/i/2016/224/3/5/hinata_naruto_beach_day_by_sakimichan-dadofi7.jpg',
          height: 400,
          width: 309,
          transparency: false,
          filesize: 189662,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://pre00.deviantart.net/be21/th/pre/i/2016/224/3/5/hinata_naruto_beach_day_by_sakimichan-dadofi7.jpg',
          height: 1017,
          width: 786,
          transparency: false,
          filesize: 189662,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://pre00.deviantart.net/be21/th/pre/i/2016/224/3/5/hinata_naruto_beach_day_by_sakimichan-dadofi7.jpg',
          height: 1017,
          width: 786,
          transparency: false,
          filesize: 189662,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://img00.deviantart.net/8c47/i/2016/224/3/5/hinata_naruto_beach_day_by_sakimichan-dadofi7.jpg',
          height: 1035,
          width: 800,
          transparency: false,
          filesize: 189662,
          isDefault: false,
        },
      ],
      deviationId: 627636607,
      typeId: 1,
      isJournal: false,
      publishedTime: '2016-08-11T17:18:20-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 734816,
    parentId: null,
  },
  {
    type: 'gallery',
    name: 'Artbook Project',

    owner: {
      username: 'sakimichan',
      usericon: 'https://a.deviantart.net/avatars/s/a/sakimichan.jpg?4',
      type: 'senior',
      userId: 2321415,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 61,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/sakimichan/art/Horoscope-artbook-up-preorder-719489461',
      title: 'Horoscope artbook up preorder',
      author: {
        username: 'sakimichan',
        usericon: 'https://a.deviantart.net/avatars/s/a/sakimichan.jpg?4',
        type: 'senior',
        userId: 2321415,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 40,
        favourites: 1342,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/tsA5Cl4YnJirG2_yl_95Gbh1HZc=/fit-in/150x150/filters:no_upscale():origin()/pre00/ce2a/th/pre/f/2017/344/4/7/horoscope_artbook_preorder_by_sakimichan-dbwd5md.jpg',
          height: 150,
          width: 133,
          transparency: false,
          filesize: 982438,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/N37sUUMxV8lcidwc1kFva9UvpGI=/300x200/filters:fixed_height(100,100):origin()/pre00/ce2a/th/pre/f/2017/344/4/7/horoscope_artbook_preorder_by_sakimichan-dbwd5md.jpg',
          height: 200,
          width: 177,
          transparency: false,
          filesize: 982438,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/0_vIU7FZFLBkcHD-u2eMmc0PpLg=/fit-in/300x900/filters:no_upscale():origin()/pre00/ce2a/th/pre/f/2017/344/4/7/horoscope_artbook_preorder_by_sakimichan-dbwd5md.jpg',
          height: 339,
          width: 300,
          transparency: false,
          filesize: 982438,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/qyw-hcOycS48il9J3Ann8UVhHzc=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/ce2a/th/pre/f/2017/344/4/7/horoscope_artbook_preorder_by_sakimichan-dbwd5md.jpg',
          height: 250,
          width: 221,
          transparency: false,
          filesize: 982438,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/ce785Fy7Gbxid3sdYE2uCRyBCvw=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/ce2a/th/pre/f/2017/344/4/7/horoscope_artbook_preorder_by_sakimichan-dbwd5md.jpg',
          height: 350,
          width: 310,
          transparency: false,
          filesize: 982438,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/r0ql_s7dFnMbj9pry6YaNG5_M48=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/ce2a/th/pre/f/2017/344/4/7/horoscope_artbook_preorder_by_sakimichan-dbwd5md.jpg',
          height: 400,
          width: 354,
          transparency: false,
          filesize: 982438,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://pre00.deviantart.net/ce2a/th/pre/f/2017/344/4/7/horoscope_artbook_preorder_by_sakimichan-dbwd5md.jpg',
          height: 950,
          width: 841,
          transparency: false,
          filesize: 982438,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://pre00.deviantart.net/ce2a/th/pre/f/2017/344/4/7/horoscope_artbook_preorder_by_sakimichan-dbwd5md.jpg',
          height: 950,
          width: 841,
          transparency: false,
          filesize: 982438,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/cbad/f/2017/344/4/7/horoscope_artbook_preorder_by_sakimichan-dbwd5md.jpg',
          height: 1035,
          width: 917,
          transparency: false,
          filesize: 982438,
          isDefault: false,
        },
      ],
      deviationId: 719489461,
      typeId: 1,
      isJournal: false,
      publishedTime: '2017-12-10T17:33:16-0800',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: false,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 44499083,
    parentId: null,
  },
  {
    type: 'gallery',
    name: 'Death note Fanart',

    owner: {
      username: 'sakimichan',
      usericon: 'https://a.deviantart.net/avatars/s/a/sakimichan.jpg?4',
      type: 'senior',
      userId: 2321415,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 3,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/sakimichan/art/Death-Note-chronicale-fixed-123051926',
      title: 'Death Note chronicale -fixed-',
      author: {
        username: 'sakimichan',
        usericon: 'https://a.deviantart.net/avatars/s/a/sakimichan.jpg?4',
        type: 'senior',
        userId: 2321415,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 2986,
        favourites: 49977,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/vYfb6Q7mcgNAuPvzo1NHCyKCsJQ=/fit-in/150x150/filters:no_upscale():origin()/pre00/9b32/th/pre/i/2015/124/1/8/death_note_chronicale__fixed__by_sakimichan-d219fh2.jpg',
          height: 108,
          width: 150,
          transparency: false,
          filesize: 203572,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/ma5O2VLXxq1iu8365kmMZjhxEc8=/300x200/filters:fixed_height(100,100):origin()/pre00/9b32/th/pre/i/2015/124/1/8/death_note_chronicale__fixed__by_sakimichan-d219fh2.jpg',
          height: 200,
          width: 277,
          transparency: false,
          filesize: 203572,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/oO69sdKIpm3XIPX-AQbFg2GE7ec=/fit-in/300x900/filters:no_upscale():origin()/pre00/9b32/th/pre/i/2015/124/1/8/death_note_chronicale__fixed__by_sakimichan-d219fh2.jpg',
          height: 217,
          width: 300,
          transparency: false,
          filesize: 203572,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/cf7CZ4uQn4et_dam50bHmBJlSHQ=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/9b32/th/pre/i/2015/124/1/8/death_note_chronicale__fixed__by_sakimichan-d219fh2.jpg',
          height: 250,
          width: 346,
          transparency: false,
          filesize: 203572,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/CnM3KYCdILb-Hw2I2rSfmn-DLZk=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/9b32/th/pre/i/2015/124/1/8/death_note_chronicale__fixed__by_sakimichan-d219fh2.jpg',
          height: 350,
          width: 485,
          transparency: false,
          filesize: 203572,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/H5mb4F4kay_eONxKJ2QXBA0PubA=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/9b32/th/pre/i/2015/124/1/8/death_note_chronicale__fixed__by_sakimichan-d219fh2.jpg',
          height: 400,
          width: 554,
          transparency: false,
          filesize: 203572,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://img00.deviantart.net/c608/i/2015/124/1/8/death_note_chronicale__fixed__by_sakimichan-d219fh2.jpg',
          height: 578,
          width: 800,
          transparency: false,
          filesize: 203572,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://img00.deviantart.net/c608/i/2015/124/1/8/death_note_chronicale__fixed__by_sakimichan-d219fh2.jpg',
          height: 578,
          width: 800,
          transparency: false,
          filesize: 203572,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://img00.deviantart.net/c608/i/2015/124/1/8/death_note_chronicale__fixed__by_sakimichan-d219fh2.jpg',
          height: 578,
          width: 800,
          transparency: false,
          filesize: 203572,
          isDefault: false,
        },
      ],
      deviationId: 123051926,
      typeId: 1,
      isJournal: false,
      publishedTime: '2009-05-19T14:40:37-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 734836,
    parentId: null,
  },
  {
    type: 'gallery',
    name: 'Picks',

    owner: {
      username: 'sakimichan',
      usericon: 'https://a.deviantart.net/avatars/s/a/sakimichan.jpg?4',
      type: 'senior',
      userId: 2321415,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 64,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/sakimichan/art/Winter-Melon-Elf-tutorial-pack-promo-576777610',
      title: 'Winter Melon Elf tutorial pack.promo.',
      author: {
        username: 'sakimichan',
        usericon: 'https://a.deviantart.net/avatars/s/a/sakimichan.jpg?4',
        type: 'senior',
        userId: 2321415,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 41,
        favourites: 1753,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/-Fkgon1JYHznsCjAGpNQJtYz1OI=/fit-in/150x150/filters:no_upscale():origin()/pre00/128e/th/pre/i/2015/341/d/4/winter_melon_elf_tutorial_pack_promo__by_sakimichan-d9jecga.jpg',
          height: 121,
          width: 150,
          transparency: false,
          filesize: 268794,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/F86HEBzUyDzh_gXUm5aku6TcPFM=/300x200/filters:fixed_height(100,100):origin()/pre00/128e/th/pre/i/2015/341/d/4/winter_melon_elf_tutorial_pack_promo__by_sakimichan-d9jecga.jpg',
          height: 200,
          width: 248,
          transparency: false,
          filesize: 268794,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/YkYR3BrXoNCF2BgvZ-AoJ1YFV-o=/fit-in/300x900/filters:no_upscale():origin()/pre00/128e/th/pre/i/2015/341/d/4/winter_melon_elf_tutorial_pack_promo__by_sakimichan-d9jecga.jpg',
          height: 242,
          width: 300,
          transparency: false,
          filesize: 268794,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/cXZWvXTi_X5MQ3GywbWuAQCH24I=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/128e/th/pre/i/2015/341/d/4/winter_melon_elf_tutorial_pack_promo__by_sakimichan-d9jecga.jpg',
          height: 250,
          width: 311,
          transparency: false,
          filesize: 268794,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/-gMguGZzMPjPomh_605OE4N0mN0=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/128e/th/pre/i/2015/341/d/4/winter_melon_elf_tutorial_pack_promo__by_sakimichan-d9jecga.jpg',
          height: 350,
          width: 435,
          transparency: false,
          filesize: 268794,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/pUsVYPzXGseu3FocpYIXEVodZ9o=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/128e/th/pre/i/2015/341/d/4/winter_melon_elf_tutorial_pack_promo__by_sakimichan-d9jecga.jpg',
          height: 400,
          width: 497,
          transparency: false,
          filesize: 268794,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://img00.deviantart.net/4036/i/2015/341/d/4/winter_melon_elf_tutorial_pack_promo__by_sakimichan-d9jecga.jpg',
          height: 725,
          width: 900,
          transparency: false,
          filesize: 268794,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://img00.deviantart.net/4036/i/2015/341/d/4/winter_melon_elf_tutorial_pack_promo__by_sakimichan-d9jecga.jpg',
          height: 725,
          width: 900,
          transparency: false,
          filesize: 268794,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://img00.deviantart.net/4036/i/2015/341/d/4/winter_melon_elf_tutorial_pack_promo__by_sakimichan-d9jecga.jpg',
          height: 725,
          width: 900,
          transparency: false,
          filesize: 268794,
          isDefault: false,
        },
      ],
      deviationId: 576777610,
      typeId: 1,
      isJournal: false,
      publishedTime: '2015-12-07T17:43:55-0800',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 26151914,
    parentId: null,
  },
  {
    type: 'gallery',
    name: 'the Sexy dark side',

    owner: {
      username: 'sakimichan',
      usericon: 'https://a.deviantart.net/avatars/s/a/sakimichan.jpg?4',
      type: 'senior',
      userId: 2321415,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 134,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/sakimichan/art/Tifa-nsfw-tag-760688173',
      title: 'Tifa.nsfw tag.',
      author: {
        username: 'sakimichan',
        usericon: 'https://a.deviantart.net/avatars/s/a/sakimichan.jpg?4',
        type: 'senior',
        userId: 2321415,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 0,
        favourites: 10,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/YlptvM3eHMCIJSuvb8a6nIJnJ0k=/fit-in/150x150/filters:no_upscale():origin()/pre00/1f92/th/pre/f/2018/234/5/4/tifa_fulllace_nsfw_02_by_sakimichan-dckw6r1.jpg',
          height: 150,
          width: 150,
          transparency: false,
          filesize: 227331,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/okFdPjXu94KOyJ74RTt8yeiUm8M=/300x200/filters:fixed_height(100,100):origin()/pre00/1f92/th/pre/f/2018/234/5/4/tifa_fulllace_nsfw_02_by_sakimichan-dckw6r1.jpg',
          height: 200,
          width: 200,
          transparency: false,
          filesize: 227331,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/AVQOVokAwl9frAxVjFN1RuW3APA=/fit-in/300x900/filters:no_upscale():origin()/pre00/1f92/th/pre/f/2018/234/5/4/tifa_fulllace_nsfw_02_by_sakimichan-dckw6r1.jpg',
          height: 300,
          width: 300,
          transparency: false,
          filesize: 227331,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/zv2H9TPNmxetKxI845IhwTbrZNw=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/1f92/th/pre/f/2018/234/5/4/tifa_fulllace_nsfw_02_by_sakimichan-dckw6r1.jpg',
          height: 250,
          width: 250,
          transparency: false,
          filesize: 227331,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/HrtxphfR4ggpTqJqWJ2TCVgMsHU=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/1f92/th/pre/f/2018/234/5/4/tifa_fulllace_nsfw_02_by_sakimichan-dckw6r1.jpg',
          height: 350,
          width: 350,
          transparency: false,
          filesize: 227331,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/vy_k3gNVfwjskyXWaH_4cTkD8MY=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/1f92/th/pre/f/2018/234/5/4/tifa_fulllace_nsfw_02_by_sakimichan-dckw6r1.jpg',
          height: 400,
          width: 400,
          transparency: false,
          filesize: 227331,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://orig00.deviantart.net/1dd3/f/2018/234/5/4/tifa_fulllace_nsfw_02_by_sakimichan-dckw6r1.jpg',
          height: 410,
          width: 410,
          transparency: false,
          filesize: 227331,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://st.deviantart.net/misc/noentrythumb-200.png',
          height: 200,
          width: 200,
          transparency: false,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/1dd3/f/2018/234/5/4/tifa_fulllace_nsfw_02_by_sakimichan-dckw6r1.jpg',
          height: 410,
          width: 410,
          transparency: false,
          filesize: 227331,
          isDefault: false,
        },
      ],
      deviationId: 760688173,
      typeId: 1,
      isJournal: false,
      publishedTime: '2018-08-22T18:04:36-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: false,
      isCommentable: false,
      isFavourited: false,
      isDeleted: false,
      isMature: true,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 54740238,
    parentId: null,
  },
];

export const galleriesFolderAll: PapiGallection = {
  type: 'gallery',
  name: 'All',

  owner: {
    username: 'ursulav',
    usericon: 'https://a.deviantart.net/avatars/u/r/ursulav.gif',
    type: 'senior',
    userId: 253062,
    useridUuid: '',
    isNewDeviant: true,
  },
  size: 999,
  additionalThumbs: null,
  thumb: {
    url: 'https://www.deviantart.com/ursulav/art/The-Biting-Pear-of-Salamanca-29677500',
    title: 'The Biting Pear of Salamanca',
    author: {
      username: 'ursulav',
      usericon: 'https://a.deviantart.net/avatars/u/r/ursulav.gif',
      type: 'senior',
      userId: 253062,
      useridUuid: '',
      isNewDeviant: true,
    },
    stats: {
      comments: 5106,
      favourites: 21200,
    },
    files: [
      {
        type: '150',
        src: 'https://t00.deviantart.net/JRq7VffYmaztN0A9e0J1Rsr_eeI=/fit-in/150x150/filters:no_upscale():origin()/pre00/f678/th/pre/i/2006/058/0/9/the_biting_pear_of_salamanca_by_ursulav.jpg',
        height: 150,
        width: 113,
        transparency: false,
        filesize: 97689,
        isDefault: false,
      },
      {
        type: '200H',
        src: 'https://t00.deviantart.net/_no4-TudXm6A1ndQ2neqMuhJe8A=/300x200/filters:fixed_height(100,100):origin()/pre00/f678/th/pre/i/2006/058/0/9/the_biting_pear_of_salamanca_by_ursulav.jpg',
        height: 200,
        width: 150,
        transparency: false,
        filesize: 97689,
        isDefault: false,
      },
      {
        type: '300W',
        src: 'https://t00.deviantart.net/4tlQhopwqeTBYGXNLVSftJP7010=/fit-in/300x900/filters:no_upscale():origin()/pre00/f678/th/pre/i/2006/058/0/9/the_biting_pear_of_salamanca_by_ursulav.jpg',
        height: 400,
        width: 300,
        transparency: false,
        filesize: 97689,
        isDefault: false,
      },
      {
        type: '250T',
        src: 'https://t00.deviantart.net/3xo-0oUTLkEyUCRttPdQ7FfhCgE=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/f678/th/pre/i/2006/058/0/9/the_biting_pear_of_salamanca_by_ursulav.jpg',
        height: 250,
        width: 188,
        transparency: false,
        filesize: 97689,
        isDefault: false,
      },
      {
        type: '350T',
        src: 'https://t00.deviantart.net/ZL860gOeGrOXXwPLKvMRiBEnv-s=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/f678/th/pre/i/2006/058/0/9/the_biting_pear_of_salamanca_by_ursulav.jpg',
        height: 350,
        width: 263,
        transparency: false,
        filesize: 97689,
        isDefault: false,
      },
      {
        type: '400T',
        src: 'https://t00.deviantart.net/qQ3lCqr7bj4HyThwixBc5b3zIec=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/f678/th/pre/i/2006/058/0/9/the_biting_pear_of_salamanca_by_ursulav.jpg',
        height: 400,
        width: 300,
        transparency: false,
        filesize: 97689,
        isDefault: false,
      },
      {
        type: 'preview',
        src: 'https://img00.deviantart.net/f986/i/2006/058/0/9/the_biting_pear_of_salamanca_by_ursulav.jpg',
        height: 750,
        width: 563,
        transparency: false,
        filesize: 97689,
        isDefault: false,
      },
      {
        type: 'social_preview',
        src: 'https://img00.deviantart.net/f986/i/2006/058/0/9/the_biting_pear_of_salamanca_by_ursulav.jpg',
        height: 750,
        width: 563,
        transparency: false,
        filesize: 97689,
        isDefault: false,
      },
      {
        type: 'fullview',
        src: 'https://img00.deviantart.net/f986/i/2006/058/0/9/the_biting_pear_of_salamanca_by_ursulav.jpg',
        height: 750,
        width: 563,
        transparency: false,
        filesize: 97689,
        isDefault: false,
      },
    ],
    deviationId: 29677500,
    typeId: 1,
    isJournal: false,
    publishedTime: '2006-02-27T16:25:32-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPurchasable: false,
    blockReasons: [],
  },
  folderId: -1,
  parentId: null,
};

export const galleriesFolderScraps: PapiGallection = {
  type: 'gallery',
  name: 'Scraps',

  owner: {
    username: 'ursulav',
    usericon: 'https://a.deviantart.net/avatars/u/r/ursulav.gif',
    type: 'senior',
    userId: 253062,
    useridUuid: '',
    isNewDeviant: true,
  },
  size: 167,
  additionalThumbs: null,
  thumb: {
    url: 'https://www.deviantart.com/ursulav/art/Knight-and-Dragon-18205862',
    title: 'Knight and Dragon',
    author: {
      username: 'ursulav',
      usericon: 'https://a.deviantart.net/avatars/u/r/ursulav.gif',
      type: 'senior',
      userId: 253062,
      useridUuid: '',
      isNewDeviant: true,
    },
    stats: {
      comments: 204,
      favourites: 1172,
    },
    files: [
      {
        type: '150',
        src: 'https://t00.deviantart.net/mz7eT5XXzPWeRtuI85Qk3zhlk2s=/fit-in/150x150/filters:no_upscale():origin()/pre00/e1b1/th/pre/i/2005/131/a/7/knight_and_dragon_by_ursulav.jpg',
        height: 100,
        width: 150,
        transparency: false,
        filesize: 38472,
        isDefault: false,
      },
      {
        type: '200H',
        src: 'https://t00.deviantart.net/ymIDqM6ccvYg6xh6a_gCwvR8YCE=/300x200/filters:fixed_height(100,100):origin()/pre00/e1b1/th/pre/i/2005/131/a/7/knight_and_dragon_by_ursulav.jpg',
        height: 200,
        width: 300,
        transparency: false,
        filesize: 38472,
        isDefault: false,
      },
      {
        type: '300W',
        src: 'https://t00.deviantart.net/qKGAB39oyBXjDE6hbVPQ1qUrciI=/fit-in/300x900/filters:no_upscale():origin()/pre00/e1b1/th/pre/i/2005/131/a/7/knight_and_dragon_by_ursulav.jpg',
        height: 200,
        width: 300,
        transparency: false,
        filesize: 38472,
        isDefault: false,
      },
      {
        type: '250T',
        src: 'https://t00.deviantart.net/27RoN4MAOGtwmKUIVS6auKmQDcg=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/e1b1/th/pre/i/2005/131/a/7/knight_and_dragon_by_ursulav.jpg',
        height: 250,
        width: 375,
        transparency: false,
        filesize: 38472,
        isDefault: false,
      },
      {
        type: '350T',
        src: 'https://t00.deviantart.net/IeXoVOMiM7tZlOGkVE2_1dXLSrI=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/e1b1/th/pre/i/2005/131/a/7/knight_and_dragon_by_ursulav.jpg',
        height: 350,
        width: 525,
        transparency: false,
        filesize: 38472,
        isDefault: false,
      },
      {
        type: '400T',
        src: 'https://t00.deviantart.net/QNIJYd6iCO0Bzgul5t5vB9b3qXI=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/e1b1/th/pre/i/2005/131/a/7/knight_and_dragon_by_ursulav.jpg',
        height: 400,
        width: 600,
        transparency: false,
        filesize: 38472,
        isDefault: false,
      },
      {
        type: 'preview',
        src: 'https://img00.deviantart.net/f9e3/i/2005/131/a/7/knight_and_dragon_by_ursulav.jpg',
        height: 433,
        width: 650,
        transparency: false,
        filesize: 38472,
        isDefault: false,
      },
      {
        type: 'social_preview',
        src: 'https://img00.deviantart.net/f9e3/i/2005/131/a/7/knight_and_dragon_by_ursulav.jpg',
        height: 433,
        width: 650,
        transparency: false,
        filesize: 38472,
        isDefault: false,
      },
      {
        type: 'fullview',
        src: 'https://img00.deviantart.net/f9e3/i/2005/131/a/7/knight_and_dragon_by_ursulav.jpg',
        height: 433,
        width: 650,
        transparency: false,
        filesize: 38472,
        isDefault: false,
      },
    ],
    deviationId: 18205862,
    typeId: 1,
    isJournal: false,
    publishedTime: '2005-05-11T11:16:15-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPurchasable: false,
    blockReasons: [],
  },
  folderId: -2,
  parentId: null,
};
